import * as Yup from 'yup';

export const basicFiltersValidations = Yup.object().shape({
	aspectRatio: Yup.string().required('Select an aspect ratio'),
	photoCompositionStyle: Yup.string().required('Please select a photo composition style'),
	roomType: Yup.string().required('Please select a room type'),
	stylize: Yup.string().required('Please select style strength'),
});
